import { render, staticRenderFns } from "./EiArticleDetail.vue?vue&type=template&id=43babd57&scoped=true&"
import script from "./EiArticleDetail.vue?vue&type=script&lang=js&"
export * from "./EiArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./EiArticleDetail.vue?vue&type=style&index=0&id=43babd57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43babd57",
  null
  
)

export default component.exports